import React from 'react'
import { useSelector } from 'react-redux'
import { useInView } from 'react-intersection-observer'

import Breadcrumb from '../breadcrumb'
import Wysiwyg from '../wysiwyg'
import Image from '../image'
import ButtonArrow from '../buttonArrow'

import trads from '../../intl/trads.json'

import roundShape from '../../icons/round-shape.svg'
import semiroundShape from '../../icons/semiround-shape.svg'
import quadShape from '../../icons/quad-shape.svg'

const Hero = ({data, currentUrl, type = null, subType = null, customType = null, isNewsroom = false, blogHubTitle= false, fromSimulator = false }) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const lang = useSelector(state => state.lang)
  let chapo = (data.chapo) ? data.chapo : null
  const breadcrumbLabel = (data.breadcrumbCurrentLabel) ? data.breadcrumbCurrentLabel : data.title
  
  let quadColor = 'gradient-blue'
  let roundColor = 'turquoise'

  let date = ''
  const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' }

  if (type === 'news') {
    date = new Date(data.publicationDate).toLocaleDateString(lang, dateOptions)
  }

  let pdf, annexes

  if (data.pressRelease) {
    data.pressRelease = (data.pressRelease.fields) ? data.pressRelease.fields : data.pressRelease
    pdf = (data.pressRelease.pdf.fields) ? data.pressRelease.pdf.fields : data.pressRelease.pdf
    
    if (data.pressRelease.annexes) {
      annexes = (data.pressRelease.annexes.fields) ? data.pressRelease.annexes.fields : data.pressRelease.annexes
    }
  }

  if(data.document) {
    data.document = (data.document.fields) ? data.document.fields : data.document
  }

  if (type === 'contact') {
    quadColor = 'sienne'
    roundColor = 'orange'
  }

  if (fromSimulator) {
    roundColor = 'purple'
    quadColor = 'gradient-green'
  }

  return (
    <div className={`hero relative ${inView ? 'has-anim' : ''}`} ref={ref}>
      <Breadcrumb 
        currentUrl={currentUrl}
        links={data.breadcrumb ? data.breadcrumb : null} 
        current={breadcrumbLabel} 
        type={type}
        subType={subType}
        customType={customType}
        isAbsolute={true}
        hasEllipsis={isNewsroom}
        blogHubTitle={blogHubTitle}
      />
      <div className="row mb-10 md:mb-20 items-start">
        <div className="col-12 md-col-6 order-last md:order-first">
          <div className="relative">
            <svg className={`absolute ${fromSimulator ? 'icon-green' : 'icon-night' } hero__semiround`} width="120" height="123">
              <use xlinkHref={semiroundShape.url} />
            </svg>

            <div className="hero__title scroll-anim-el">
              { type === 'news' &&
                <p className="text-label text-purple mb-3">{ lang === 'fr' ? 'Le' : 'The'} { date }</p>
              }
              <h1 className="title title-page">{data.title}</h1>
            </div>
            
            <div className="scroll-anim-el scroll-anim-el--2">
              { chapo &&
                <div className="row mt-6 md:mt-10">
                  <div className="col-12 xl-col-5">
                    <Wysiwyg classes="paragraph-big" document={chapo} />
                  </div>
                </div>
              }

              {data.pressRelease &&
                <div className="mt-10">
                  <ButtonArrow text={trads[lang].newsroom.newsPressRelease} link={pdf.file.url} external="true" color="night" />

                  { annexes &&
                    <div className="mt-4">
                      <ButtonArrow
                        text={trads[lang].newsroom.newsAnnexes}
                        link={annexes.file.url}
                        external="true"
                        color="night"
                        icon="dl" />
                    </div>
                  }
                </div>
              }

              { data.document && !data.pressRelease &&
                <div className="mt-10">
                  <ButtonArrow text={trads[lang].newsroom.newsDocument} link={data.document.file.url} external="true" color="night" />
                </div>
              }
            </div>
          </div>
        </div>
        <div className="col-12 md-col-offset-1 md-col-5 relative">
          <div className="hero__shape hero__shape--not-hp shaped-image shaped-image--hero">
            { data.mainImage &&
            <Image
              width="950"
              height="848"
              isTop={true}
              classes="object-fit-image hero__img"
              sizes={{"415": [380, 420], "767": [750, 860], "1023": [465, 610], "1440": [705, 848] }}
              image={data.mainImage} />
            }
          </div>
          <svg className={`absolute icon-${quadColor} hero__quad`} width="120px" height="120px">
            <use xlinkHref={quadShape.url} />
          </svg>
          <svg className={`absolute icon-${roundColor} hero__round`} width="65px" height="65px">
            <use xlinkHref={roundShape.url} />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default Hero
